<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
    name: "PromoCodesButton",
    props: ['id']
})
</script>

<template>
<div class="cursor-pointer">
  <el-tooltip
    popper-class="custom-tooltip"
    content="Промокоди"
    placement="top-start"
  >
    <router-link tag="div" :to="{name: 'partner-promo-codes', params: {id: id}}" class="promo-codes-button">
        <img src="~@/assets/images/icons/promocode.svg" alt="Промокоди">
    </router-link>
  </el-tooltip>
</div>
</template>

<style scoped>
/* та сама плитка 40×40, що й у сусідніх кнопок дій партнера */
.promo-codes-button {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    background: #FAFAFA;
    display: flex;
    align-items: center;
    justify-content: center;
}

.promo-codes-button img {
    width: 16px;
    height: 16px;
}
</style>
